const constants = {
  ROUTES: {
    HOME: "/home",
    CONTACT_US: "/contactUs",
    LOGIN: "/login",
  },
  HTTP_REQ_DEFAULT_HEADERS: {
    Accept: "application/json",
    "Content-Type": "application/json; charset=UTF-8",
  },
  HTTP_MULTIPART_FORM_HEADERS: {
    Accept: "application/json",
    "Content-Type": "application/json; charset=UTF-8",
  },
  HTTP_METHODS: {
    POST: "POST",
    GET: "GET",
    DELETE: "DELETE",
    PATCH: "PATCH",
    PUT: "PUT",
  },

  HOME: {
    WELCOME: "WELCOME TO",
  },
  ROLES: {
    CP_ADMIN: "ROLE_CPADMIN",
    HO_ADMIN: "ROLE_HOADMIN",
    HUB_ADMIN: "ROLE_HUBADMIN",
    CP_OPERATOR: "ROLE_CPOPERATOR",
    CP_BOOKINGONLY: "ROLE_CPBOOKINGONLY",
    CLIENT_ADMIN: "ROLE_CLIENTADMIN",

    ROLE_HOMARKETING: "ROLE_HOMARKETING",
    DP_OPERATOR: "ROLE_DPOPERATOR",
    HO_LEGAL: "ROLE_HOLEGAL",
    HO_FINANCE: "ROLE_HOFINANCE",
    CENTRALOPERATOR: "ROLE_CENTRALOPERATOR",
    CENTRALOPS_ADMIN: "ROLE_CENTRALOPSADMIN",
    MIS_EXECUTIVE: "ROLE_MISEXECUTIVE",
  },
  CAMPAIGN_NAME: "standard_v20",

  WHATSAPPKEY:
    // eslint-disable-next-line max-len
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjY1ODAyMmZmODExOGRhNTQ0YmVkMTVmMCIsIm5hbWUiOiJTSFJJIE1BUlVUSSBJTlRFR1JBVEVEIExPR0lTVElDUyBMSU1JVEVEIiwiYXBwTmFtZSI6IkFpU2Vuc3kiLCJjbGllbnRJZCI6IjY1ODAyMjdmMDllNTBkMTBkMDA2Yjk1OCIsImFjdGl2ZVBsYW4iOiJOT05FIiwiaWF0IjoxNzAyODk2MzgzfQ.57vK6P_o4ABg9feJanqUVjyGXubEsNGFQ1KAWKCYoR4",
  PALLETIT_FORM_URL:
    "https://docs.google.com/forms/d/e/1FAIpQLSdvdR5ied0FOI2uytGrtNhQu-xWhkzpIRZxPq5p1lOuvuwqMw/viewform",
  ISMART_SENSE_FORM_URL: "https://forms.gle/F4UTiHHu2AL1VaCQ7",
  ONE_BOOKING_APP_URL:
    "https://play.google.com/store/apps/details?id=io.prayog.ismartsense.smile",
};

export default constants;
